import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ConfigService } from './config.service';
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs';
import { User } from '../models/user.model';
import { first, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { v4 as uuid } from 'uuid';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private httpClient: HttpClient, private _cookieService: CookieService, private configService: ConfigService, private authService: AuthService) {}

  private loadingUser: Promise<any>;
  public user: User;
  public userLoaded: boolean = false;
  public authFailed: boolean = false;

  getUserToken(code: string, isGame: boolean) {
    console.log('code and isgame',isGame);
    return this.httpClient.get(`${environment.apis.thirdParty}/vsp-auth?code=${code}&isGame=${isGame}`);
  }

  loadUser(): Observable<User> {
    console.log('authheaders',this.authService.authHeaders);
    return this.httpClient.get<any>(`${environment.apis.thirdParty}/users`, { headers: this.authService.authHeaders }).pipe(first(), map((response: User) => {
      if (!this._cookieService.get('user_session')) {
        this._cookieService.set('user_session', uuid());
      }

      this.user = new User(response);
      this.userLoaded = true;
      console.log('loaded user',this.user);
      if(this.user.businessFunction =='dealeradmin')
      {
        this.user.isAdmin = true;
        this.user.language = 'eng';
      }
      
      return this.user;
    }))
  }

  loadTonicUser(): Observable<User> {
    return this.httpClient.get<User>(`${environment.apis.thirdParty}/users`).pipe(first(), map((response: User) => {
      if (response == null) {
        this.authFailed = true;
        throw new Error("failed to load Users");
      }
      this.user = new User(response);
      this.user.isAdmin = true;
      // this.user.businessFunction = 'PSC';

      return this.user;
    }))
  }

  public getUser(): User {
    return this.user;
  }
}
